<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">{{translation.HomeHeaderTitle}}</div>
  <div class="breakLine"></div>
  <div class="row unselectable headerText">
    <div>{{translation.HomeHeaderTextLine1}}</div><br>
    <div>{{translation.HomeHeaderTextLine2}}</div>
  </div>
  <div id="moduleContent" class="row unselectable">
    <app-module
      *ngFor="let module of modules" [module]="module"
      class="col-12 col-sm-12 cotraModuleCard"
      [ngClass]="module.ModuleId !== 80 ? 'col-md-6 col-lg-6 col-xl-6' : 'col-md-12 col-lg-12 col-xl-12'"
      (click)="navigate(module.ForwardLink)">
    </app-module>
  </div>
  <div *ngIf="language === 'DE' && news.length > 0">
    <div class="row unselectable headerTitle headline">{{translation.News}} - {{translation.WhatsGoingOn}}</div>
    <div id="newsContent" class="row unselectable">
      <div class="newsCard" *ngFor="let newsitem of news" (click)="openNewsDialog(newsitem)">
        <div class="newsTopContent">
          <div class="newsText">{{newsitem.Title}}</div>
        </div>
        <div class="newsBottomContent">
          <div class="newsDate">{{newsitem.Updated | date: 'dd.MM.yyyy'}}</div>
          <div class="newsButton">{{translation.More}}</div>
        </div>
      </div>
    </div>
    <app-logos-with-link></app-logos-with-link>
  </div>
  <app-scroll-to-top></app-scroll-to-top>
</div>
<app-footer></app-footer>
